function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_x0020_1"
}, /*#__PURE__*/React.createElement("metadata", {
  id: "CorelCorpID_0Corel-Layer"
}), /*#__PURE__*/React.createElement("g", {
  id: "credit-cards-payment.svg"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M2298 312l-1463 -310c-62,-13 -124,27 -137,89l-28 179 1689 357 27 -179c13,-61 -26,-123 -88,-136z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1682 665c-17,-62 -81,-98 -143,-81l-277 77 -655 -138 -72 340 -450 125c-61,17 -98,81 -81,143l254 913c17,62 81,98 143,81l1454 -403c62,-18 98,-82 81,-143l-44 -157 164 34c61,13 123,-27 136,-88l103 -488 -587 -124 -26 -91zm168 464l36 -170c6,-25 31,-42 56,-36l170 36c26,5 42,30 37,56l-36 170c-5,25 -31,42 -56,36l-170 -36c-26,-5 -42,-30 -37,-56zm-1740 -50l403 -112 950 -263 102 -29c2,0 3,0 5,0 8,0 18,5 21,15l12 43 38 136 -1496 415 -50 -179c-3,-11 4,-23 15,-26zm1735 525c2,7 0,13 -2,16 -2,4 -6,8 -13,10l-1455 404c-1,0 -3,1 -5,1 -8,0 -18,-6 -21,-16l-148 -533 1496 -415 91 329 57 204z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M610 1640c-7,-25 -33,-40 -58,-33l-170 48c-25,7 -40,33 -33,58l47 170c7,25 34,40 59,33l170 -48c25,-6 40,-33 33,-58l-48 -170z"
})))));

var SvgCards = function SvgCards(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2389 2129",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCards, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cards.fb640ed1.svg";
export { ForwardRef as ReactComponent };